import React from "react";

interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  onSearch: () => void;
  isDarkTheme?: boolean;
}

const SearchField: React.FC<SearchFieldProps> = ({
  value,
  onChange,
  onSearch,
  isDarkTheme,
}) => {
  const handleKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      onSearch();
    }
  };

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
      <div style={{ position: "relative", display: "inline-block", width: "25%" }}>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Search: Repair Order Num, Tracking Num, Serial Num..."
          style={{
            width: "100%",
            padding: "8px",
            paddingRight: value ? "30px" : "8px",
            fontSize: "14px",
            fontFamily: "Arial, sans-serif",
            border: `1px solid ${isDarkTheme ? "#555" : "#ccc"}`,
            borderRadius: "4px",
            backgroundColor: isDarkTheme ? "#333" : "#fff",
            color: isDarkTheme ? "#fff" : "#000",
            boxSizing: "border-box"
          }}
        />
        {value && (
          <span
            onClick={() => onChange("")}
            style={{
              position: "absolute",
              right: "8px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: isDarkTheme ? "#ccc" : "#666",
              fontSize: "20px",
              fontWeight: "bold"
            }}
          >
            ×
          </span>
        )}
      </div>
      <button
        onClick={onSearch}
        style={{
          padding: "8px 16px",
          fontSize: "14px",
          fontFamily: "Arial, sans-serif",
          border: "none",
          borderRadius: "4px",
          backgroundColor: "#007bff",
          color: "white",
          cursor: "pointer",
          transition: "background-color 0.3s"
        }}
        onMouseOver={(e) => e.currentTarget.style.backgroundColor = "#0056b3"}
        onMouseOut={(e) => e.currentTarget.style.backgroundColor = "#007bff"}
      >
        Search
      </button>
    </div>
  );
};

export default SearchField;
